<template>
  <svg :viewBox="svg.viewBox" :width="width" role="img" :aria-label="ariaLabel" v-bind="attr">
    <use :href="`#${svg.id}`" />
  </svg>
</template>

<script setup lang="ts">
import { useAttrs } from 'vue';

defineProps<{
  svg: {
    viewBox: string;
    id: string;
  };
  width?: string;
  ariaLabel?: string;
}>();
const attr = useAttrs();
</script>
